<div *ngIf="!isLoading">
    <div class="content" *ngIf="!consentDetail">
        <div class="row" *ngIf="stateDialog === ''">
            <div class="box-info"
                [ngClass]="{ 'im3' : platform === 'im3', 'indosat' : platform === 'indosat' || platform === 'tri' }">
                {{ "updated_consent" | translate }}
                <br>
                <p class="more" (click)="learnMore('ioh')"
                    [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'text-orange' : platform === 'tri' }">
                    {{ "more" | translate }}
                </p>
            </div>
            <p class="consent-title"
                [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat' || platform === 'tri' }">
                {{ "personalized" | translate }}
            </p>
            <p class="consent-content"
                [ngClass]="{ 'im3' : platform === 'im3', 'indosat' : platform === 'indosat' || platform === 'tri' }">
                {{ "personalized_consent" | translate }}
            </p>
            <br>
            <p class="more" (click)="learnMore('other')"
                [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'text-orange' : platform === 'tri' }">
                {{ "more" | translate }}
            </p>
        </div>
        <div class="text-center">
            <!-- <app-dialog *ngIf="stateDialog !== '' " [dialogType]="stateDialog" [showButton]="showButton"
            (btnAction)="btnAction()"></app-dialog> -->
            <app-dialog-consent *ngIf="stateDialog !== '' " [dialogType]="stateDialog" [showButton]="showButton"
                (btnAction)="manageAction()"></app-dialog-consent>
        </div>
    </div>

    <div class="content" *ngIf="consentDetail">
        <div class="row mb-4">
            <p class="consent-content"
                [ngClass]="{ 'im3' : platform === 'im3', 'indosat' : platform === 'indosat' || platform === 'tri' }">
                {{ "consent_detail_1" | translate }}
            </p>
            <p class="consent-content mt-2"
                [ngClass]="{ 'im3' : platform === 'im3', 'indosat' : platform === 'indosat' || platform === 'tri' }">
                {{ "consent_detail_2" | translate }}
                <u [ngClass]="{ 'text-red' : platform !== 'tri', 'text-orange' : platform === 'tri' }">{{
                    "consent_detail_3"
                    | translate }}</u>
                {{ "consent_detail_4" | translate }}
            </p>
        </div>

        <div class="row mt-1" *ngFor="let data of dataConsentGroup">
            <div class="col-10">
                <p class="consent-detail-title">
                    {{ getLang() === 'en' ? data.displayGroupName_en : data.displayGroupName_id }}
                </p>
                <p class="consent-detail-content">
                    {{ getLang() === 'en' ? data.displayContent_en : data.displayContent_id }}
                </p>
            </div>
            <div class="col-2">
                <input class="form-check-input" [ngClass]="{ 'checked-orange' : platform === 'tri' }" type="checkbox"
                    [(ngModel)]="data.response">
            </div>
        </div>

        <div class="row mt-2 mb-4">
            <p class="consent-content"
                [ngClass]="{ 'im3' : platform === 'im3', 'indosat' : platform === 'indosat' || platform === 'tri' }">
                {{ "consent_detail_5" | translate }}
                <span [ngClass]="{ 'text-red' : platform !== 'tri', 'text-orange' : platform === 'tri' }">
                    {{ "agree_to_all" | translate }}</span>
            </p>
            <p class="consent-content mt-2 mb-4 pb-4"
                [ngClass]="{ 'im3' : platform === 'im3', 'indosat' : platform === 'indosat' || platform === 'tri' }">
                <span class="pointer"
                    [ngClass]="{ 'text-red' : platform !== 'tri', 'text-orange' : platform === 'tri' }"
                    (click)="learnMore('other')">
                    {{ "more" | translate }}</span>
                {{ "consent_detail_6" | translate }}
            </p>
        </div>
    </div>

    <div class="btn-wrapper" *ngIf="!consentDetail && consent.consentStatus !== 'FC'">
        <div class="row" *ngIf="stateDialog === ''">
            <div class="col-12">
                <button class="btn-agree"
                    [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'bg-orange' : platform === 'tri' }"
                    type="button" (click)="agree()">
                    {{ "agree" | translate}}
                </button>
            </div>
            <div class="col-12">
                <button class="btn-disagree"
                    [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'text-orange' : platform === 'tri' }"
                    type="button" (click)="toConsentDetail()">
                    {{ "disagree" | translate}}
                </button>
            </div>
        </div>
    </div>

    <div class="btn-wrapper" *ngIf="consentDetail && consent.consentStatus !== 'FC'">
        <div class="row" *ngIf="stateDialog === ''">
            <div class="col-12">
                <button class="btn-agree"
                    [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'bg-orange' : platform === 'tri' }"
                    type="button" (click)="continue()">
                    {{ "continue" | translate}}
                </button>
            </div>
            <div class="col-12">
                <button class="btn-disagree"
                    [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'text-orange' : platform === 'tri' }"
                    type="button" (click)="agreeAll()">
                    {{ "agree_to_all" | translate}}
                </button>
            </div>
        </div>
    </div>

    <div class="card btn-wrapper-manage" *ngIf="consent.consentStatus === 'FC' ">
        <div class="row">
            <div class="col-9 consent-manage"
                [ngClass]="{ 'im3' : platform === 'im3', 'indosat' : platform === 'indosat' || platform === 'tri' }">
                {{ "manage_consent_FC" | translate}}
            </div>
            <div class="col-3 align-content-center">
                <p class="more text-center" (click)="manageConsent()"
                    [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'text-orange' : platform === 'tri' }">
                    {{ "manage" | translate }}
                </p>
            </div>
        </div>
    </div>
</div>


<app-loading *ngIf="isLoading"></app-loading>